"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreSimpleGrid = _interopRequireDefault(require("@legacy-vfuk/core-simple-grid"));

var _LinkList = _interopRequireDefault(require("./components/LinkList"));

var Styled = _interopRequireWildcard(require("./styles/TopBar.style"));

var _TopNavigationContext = _interopRequireDefault(require("../../context/TopNavigationContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TopBar = function TopBar() {
  var _ref = (0, _react.useContext)(_TopNavigationContext["default"]),
      topNav = _ref.topNav;

  if (!topNav) return null;
  var leftLinks = topNav.leftLinks,
      rightLinks = topNav.rightLinks,
      srText = topNav.srText;
  return /*#__PURE__*/_react["default"].createElement(Styled.TopBar, {
    "aria-label": srText
  }, /*#__PURE__*/_react["default"].createElement(Styled.Container, null, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    layout: {
      sm: [11]
    },
    justify: "right"
  }, /*#__PURE__*/_react["default"].createElement(Styled.LinksWrapper, null, leftLinks ? /*#__PURE__*/_react["default"].createElement(_LinkList["default"], {
    links: leftLinks
  }) : null, rightLinks ? /*#__PURE__*/_react["default"].createElement(_LinkList["default"], {
    links: rightLinks
  }) : null))));
};

TopBar.displayName = "TopBar";
var _default = TopBar;
exports["default"] = _default;
//# sourceMappingURL=TopBar.js.map